const newPassword = document.getElementById('new-password');


if (newPassword) {
    newPassword.onkeyup = function (event) {
        event.preventDefault();

        var password = newPassword.value;
        var activeCls = 'password-success';
        var inActiveCls = 'password-error';
        
        var specialCharPattern = /[`!%$#@&^*()]+/;
        var specialChar = $('#MinimumSpecialCharacter');
        if (password.match(specialCharPattern)) {
            specialChar.removeClass(inActiveCls);
            specialChar.addClass(activeCls);
            specialChar.find('svg').css('display', 'inline');   
        } else {
            specialChar.addClass(inActiveCls);
            specialChar.removeClass(activeCls);
            specialChar.find('svg').css('display', 'none');
        }

        var minCharPattern = /^.{8,}$/;
        var minChar = $('#MinimumCharacter');
        if (password.match(minCharPattern)) {
            minChar.removeClass(inActiveCls);
            minChar.addClass(activeCls);
            minChar.find('svg').css('display', 'inline');
        } else {
            minChar.addClass(inActiveCls);
            minChar.removeClass(activeCls);
            minChar.find('svg').css('display', 'none');
        }

        var capitalLetterPattern = /[A-Z]/g;
        var capitalLetter = $('#MinimumCapitalLetter');
        if (password.match(capitalLetterPattern)) {
            capitalLetter.removeClass(inActiveCls);
            capitalLetter.addClass(activeCls);
            capitalLetter.find('svg').css('display', 'inline');
        } else {
            capitalLetter.addClass(inActiveCls);
            capitalLetter.removeClass(activeCls);
            capitalLetter.find('svg').css('display', 'none');
        }

        var numberPattern = /\d{1}/g;
        var number = $('#MinimumNumber');
        if (password.match(numberPattern)) {
            number.removeClass(inActiveCls);
            number.addClass(activeCls);
            number.find('svg').css('display', 'inline');
        } else {
            number.removeClass(activeCls);
            number.addClass(inActiveCls);
            number.find('svg').css('display', 'none');
        }
    };
}